import Home from "pages/home";

const routes = [
  // home
  {
    path: `/home`,
    exact: true,
    auth: true,
    component: Home,
  },
];

export default routes;
